<template>
  <div class="flex align-items toggle-display">
    <template v-if="!reverse">
      <label class="control-label fontGrey marginBottom0" :class="{'col-xs-6' : halfCol}">
        <label v-html="display" class="fontBlack"></label>
        <template v-if="tooltip">
          <i
            class="fa fa-question-circle"
            aria-hidden="true"
            data-toggle="tooltip"
            data-placement="top"
            :data-original-title="tooltip"
          ></i>
        </template>
      </label>
      <!-- <label class="switch marginLeft20">
        <input
          type="checkbox"
          @change="emit"
          @keydown="form.errors.clear($event.target.name)"
          v-model="value"
          :aria-label="display || name"
        />
        <span class="slider round"></span>
      </label> -->
      <div class="marginLeft10 flexOnly align-items justifyCenter">
        <label class="form-switch">
          <input
            type="checkbox"
            @change="emit"
            @keydown="form.errors.clear($event.target.name)"
            v-model="value"
            :aria-label="ariaLabel || display || name"
            :disabled="disabled"
          />
          <span class="slider round"></span>
        </label>
        <div v-if="onNoff" class="switch-toggle-label">
          <template v-if="value == true">
            On
          </template>
          <template v-else>
            Off
          </template>
        </div>
        <div v-else class="switch-toggle-label">
          <template v-if="value == true">
            Yes
          </template>
          <template v-else>
            No
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="marginRight10 flexOnly align-items justifyCenter">
        <label class="form-switch">
          <input
            type="checkbox"
            @change="emit"
            @keydown="form.errors.clear($event.target.name)"
            v-model="value"
            :aria-label="ariaLabel || display || name"
            :disabled="disabled"
          />
          <span class="slider round"></span>
        </label>
        <div v-if="onNoff" class="switch-toggle-label">
          <template v-if="value == true">
            On
          </template>
          <template v-else>
            Off
          </template>
        </div>
        <div v-else class="switch-toggle-label">
          <template v-if="value == true">
            Yes
          </template>
          <template v-else>
            No
          </template>
        </div>
      </div>
      <!-- <label class="switch marginRight10">
        <input
          type="checkbox"
          @change="emit"
          @keydown="form.errors.clear($event.target.name)"
          v-model="value"
          :aria-label="display || name"
        />
        <span class="slider round"></span>
      </label> -->
      <label class="control-label fontGrey marginBottom0" :class="{'col-xs-6' : halfCol}">
        <label v-html="display" class="fontBlack"></label>
        <template v-if="tooltip">
          <i
            class="fa fa-question-circle"
            aria-hidden="true"
            data-toggle="tooltip"
            data-placement="top"
            :data-original-title="tooltip"
          ></i>
        </template>
      </label>
    </template>
  </div>
</template>
<script>
export default {
  props: ["display", "form", "name", "options", "disabled", "ariaLabel"],
  data() {
    return {
      value: false,
      falseval: false,
      trueval: true,
      tooltip: false,
      reverse: false,
      onNoff: false,
      halfCol: false,
    };
  },
  created() {
    this.falseval = _.get(this.options, "falseval", false);
    this.trueval = _.get(this.options, "trueval", true);
    if (this.trueval == _.get(this.form.model, this.name)) {
      this.value = true;
    } else {
      this.value = false;
    }
    this.reverse = _.get(this.options, "reverse", false);
    this.onNoff = _.get(this.options, "onNoff", false);
    this.halfCol = _.get(this.options, "halfCol", false);
  },
  methods: {
    emit(emit) {
      if (this.value == true) {
        _.set(this.form.model, this.name, this.trueval);
      } else {
        _.set(this.form.model, this.name, this.falseval);
      }

      this.$emit("changed");
    },
  },
  watch: {
    "form.model": {
      deep: true,
      handler(value, oldValue) {
        if (this.trueval == _.get(this.form.model, this.name, false)) {
          this.value = true;
        } else {
          this.value = false;
        }
      },
    },
  },
};
</script>
<style scoped>
.toggle-display label div {
  margin-top: 4px;
}
</style>
